import { stringify } from 'query-string';
import { API_URL } from '../../../app-config/constants';
import type { ResponseGrouping, SurveyResponseAggregation } from '../../../types/SurveyResponses';
import { get } from '../request';

const ENTRY = `${API_URL}/surveys`;

export type AggregationOptions = {
    grouping?: ResponseGrouping;
    reviewCycleId?: string;
    ratingId?: string;
    filters?: string[];
    /** ISO 8601 string */
    from?: string;
    /** ISO 8601 string */
    to?: string;
};

getAll.operation = 'READ';
getAll.idFrom = 'ARGS';
export function getAll(surveyId: string, options: AggregationOptions): Promise<SurveyResponseAggregation> {
    const urlParams = stringify(options);
    return get(`${ENTRY}/${surveyId}/responses` + (urlParams ? `?${urlParams}` : ''));
}
